<template>
    <form>
        <div class="input_item">
            <div class="p-float-label with-button">
                <InputText id="url" type="text" v-model="formData.url"/>
                <label for="url">{{ $t("OfficialURL") }}</label>
                <Button
                    type="button"
                    :label="$t('Get')"
                    class="p-button-outlined"
                    @click="onClickURLInformation"
                    />
            </div>
            <MultiSelect
                v-model="formData.urlTypes"
                :options="itemLinkTypes"
                optionLabel="name"
                :placeholder="$t('ItemLinkType.MultiSelectPlaceholder')"
                display="chip"/>
            <p>
                {{ $t('Enter the URL of the official website here and press the get button.Some information will be entered automatically.')}}
            </p>
        </div>

        <div class="input_item">
            <p class="required">必須</p>
            <div class="p-float-label">
                <InputText id="name" type="text" v-model="formData.name"/>
                <label for="name">{{ $t('Item name') }}</label>
            </div>
            <p class="p-float-label input-url-item">
                {{ $t('Keep the item names as simple as possible.') }}
            </p>
        </div>

        <div class="input_item">
            <p class="required">必須</p>
            <div>
                <TreeSelect
                v-model="formData.category"
                :options="categories"
                :placeholder="$t('Select category')"
                :key="id" :label="name"></TreeSelect>
            </div>
            <p class="p-float-label input-url-item">
                {{ $t('Please select the category that is closest to the item you are trying to register.') }}
            </p>
        </div>

        <div class="input_item">
            <div class="p-float-label">
                <AutoComplete  :placeholder="$t('Select maker')" :suggestions="filterMakers" @complete="searchMaker($event)" :dropdown="true" field="name" v-model="formData.maker" force-selection >
                <template #item="slotProps">
                    <div>
                        <div class="ml-2">{{slotProps.item.name}}</div>
                    </div>
                </template>
                </AutoComplete>
            </div>
            <p class="p-float-label input-url-item">
                {{ $t('Please select the manufacturer of the item. You can also search by typing.') }}
            </p>
        </div>

        <div class="input_item">
            <div class="p-float-label">
                <Chips v-model="formData.tags" />
                <label>Tags</label>
            </div>
            <p class="p-float-label input-url-item">
                {{ $t('Enter the characteristics and performance of the item as tags. Pressing Enter separates the tags.') }}
            </p>
        </div>

        <Button
            type="button"
            :label="$t('Registration')"
            class="p-button-outlined submit"
            @click="onClickStoreItem"
            />
    </form>
</template>

<script>
import {
    ref,
    onMounted,
    reactive,
    computed,
} from 'vue';
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import TreeSelect from 'primevue/treeselect';
import AutoComplete from 'primevue/autocomplete';
import axios from "axios";
import Message from 'primevue/message';
import Chips from 'primevue/chips';
import { useToast } from "primevue/usetoast";
import { errorToast } from './../../itemListError.js';
import MultiSelect from 'primevue/multiselect';

export default {
    components: {
        Button,
        InputText,
        TreeSelect,
        AutoComplete,
        Message,
        Chips,
        MultiSelect,
    },
    setup(props) {
        const toast = useToast();

        const formData = reactive({
            name: "",
            category: "",
            maker: "",
            url: "",
            tags: "",
            urlTypes: [],
        })
        const currentCategories = reactive([]);
        const categories = ref();
        const makers = ref();
        const filterMakers = ref();
        const currentMaker = ref();

        const url = ref();
        const itemLinkTypes = ref();

        const searchMaker = (event) => {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    filterMakers.value = [...makers.value];
                }
                else {
                    filterMakers.value = makers.value.filter((country) => {
                        return country.name.toLowerCase().includes(event.query.toLowerCase());
                    });
                }
            }, 250);
        };

        const load = () => {
            makers.value = JSON.parse(document.getElementById("json-data-makers").textContent)
            categories.value = JSON.parse(document.getElementById("json-data-item-categories").textContent)
            itemLinkTypes.value = JSON.parse(document.getElementById("json-data-item_link_types").textContent)

        }
        onMounted(load);

        const onClickURLInformation = function() {
            axios.get('/api/items/information', {
                params: {
                    url: formData.url
                }
            }).then(res =>  {
                formData.maker = res.data.maker ?? '';
                formData.name = res.data.title;
                formData.tags = res.data.tags ?? '';
                const category_id = res.data.category_id;
                formData.category = {[category_id]: true};
            }).catch(error => {
                errors.value = error.response.data.errors
            })
        }

        const onClickStoreItem = function() {
            const postData = {
                name: formData.name,
                item_category_id:Object.keys(formData.category)[0],
                maker_id:formData.maker.code,
                url:formData.url,
                tags: formData.tags,
                urlTypes: formData.urlTypes.flatMap((element) => {
                    return element['code']
                }),

            }
            axios.post(
                '/api/items',
                postData,
            ).then(res => {
                location.href = '/items/' + String(res.data.data.item_id);
            }).catch(error => {
                errorToast(error.response.data, toast);
            })
        }
        return {
            formData,
            categories,
            makers,
            filterMakers,
            searchMaker,
            onClickStoreItem,
            onClickURLInformation,
            itemLinkTypes,
        }
    },
}
</script>

<style lang="scss">
.p-chips .p-chips-multiple-container .p-chips-token {
    margin-top: 4px;
}
</style>
